import { menuAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle({
  list: {
    bg: 'white',
    borderRadius: 'lg',
    boxShadow: '0px 8px 24px 0px #0000001A',
    minW: 'auto',
    py: '2',
  },
  icon: {
    marginRight: '-1 !important',
    marginInlineEnd: '0 !important',
  },
  item: {
    gap: '3',
    px: '4',
    pr: '6',
    py: '3',
    fontSize: 'md',
    fontWeight: 'normal',
    color: 'grey.900',
    letterSpacing: 'less-tight',
    transition: 'all 0.15s ease',
    _hover: {
      bg: 'grey.50',
    },
    _active: {
      bg: 'grey.50',
    },
    _focus: {
      bg: 'grey.50',
      outline: 'none',
    },
    _disabled: {
      color: 'grey.400',
      cursor: 'not-allowed',
      _hover: {
        bg: 'transparent',
        color: 'grey.400',
      },
    },
  },
});

export const styleConfig = defineMultiStyleConfig({
  baseStyle,
});
